import { render } from "./EnvoiExpress.vue?vue&type=template&id=7474653a&ts=true"
import script from "./EnvoiExpress.vue?vue&type=script&lang=ts"
export * from "./EnvoiExpress.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__